import IdNameDto from '@src/adapters/dto/shared/IdNameDto';
import { useSaveMigrationConsultantLazy } from '@src/adapters/hooks/migration/useSaveMigrationItemConsultant';
import { useEffect, useState } from 'react';
import ConsultantAutoComplete from '@src/components/consultant/ConsutlantAutoComplete';

interface Props {
  migrationId: string;
  consultant?: IdNameDto;
  disabled?: boolean;
}

function Consultant({ migrationId, consultant, disabled }: Props) {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const { execute } = useSaveMigrationConsultantLazy();

  useEffect(() => {
    if (consultant) {
      setSelectedId(consultant.id);
    }
  }, [consultant]);

  const handleConsultant = (id: string | null) => {
    if (id) {
      saveConsultant(id);
    } else {
      setSelectedId(null);
    }
  };

  const saveConsultant = (id: string) => {
    execute({
      migrationId: migrationId,
      consultantId: id,
    }).then(() => {
      setSelectedId(id);
    });
  };

  return (
    <ConsultantAutoComplete
      onSelection={(id) => handleConsultant(id)}
      selectedId={selectedId}
      enableNew={true}
      disabled={disabled}
    />
  );
}

export default Consultant;
